var render = function render(){var _vm=this,_c=_vm._self._c;return _c('page-wrapper',{attrs:{"title":_vm.title}},_vm._l((_vm.list),function(item){return _c('category-list-item',_vm._b({key:item.id},'category-list-item',item,false))}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }